import { Container } from '@chakra-ui/react';
import React from 'react';

function MainContentContainer({ children }) {
  return (
    <Container
      maxW="1280px"
      margin="0px auto"
      px={{ base: '16px', md: '20px', xl: '20px', xxl: '0px', '2xl': '0px' }}
    >
      {children}
    </Container>
  );
}

export default MainContentContainer;
